export default __webpack_public_path__ + "static/media/image05.682d6ae7.jpg";